import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrums from "../../common/breadcrumbs";
import { SWAL_SETTINGS, PHONE_NO_LENGTH, INPUT_MAX_25, TEXTAREA_MAX_LENGTH } from "../../../../utils/Constants";
import {
  handleServerValidations,
  DT,
  globalLoader
} from "../../../../utils/commonfunction";
import * as Yup from "yup";
import CustomError from "../../../../utils/customError";
import { useTranslation } from "react-i18next";
import { TagPicker, Tooltip, Whisper } from "rsuite";
import PhoneInput from "../../../../utils/PhoneInput";
import { PHONE_VALIDATION } from "../../../../utils/CommonValidatiobn";
import { Details, EditUser } from "../../services/babeuser.services";


const BabeUserEdit = (props) => {
  const navigate = useNavigate();
  const params = useParams();
  const { t } = useTranslation();
  const [showdefault, setShowDefault] = useState({});
  const [previewimage, setPreviewImage] = useState("");

  const [saveType, setSaveType] = useState("");
  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    {
      title: t("link_babe_user"),
      url: "/admin/babe-user/list/1",
    },
    { title: t("btn_edit"), url: "" },
  ];

  useEffect(() => {
    Details(params._id)
      .then((response) => {
        setShowDefault(response && response.data ? response.data : []);
        setPreviewImage(response.data.profile_image);

      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [params.id]);


  console.log(showdefault);



  const validationSchema = Yup.object().shape({

    name: Yup.string()
      .trim()
      .max(100, "max_word_count_label")
      .matches(/^[A-Za-z\s]+$/, "Only alphabets and spaces are allowed")
      .required("label__name_error"),

    email: Yup.string()
      .trim()
      .email(("label_email_invalid_format_error"))
      .test('no-uppercase', ("label_email_uppercase_error"), function (value) {
        if (value) {
          return !/[A-Z]/.test(value);
        }
        return true;
      })
      .required(("label_email_required_error")),
    phone_number: PHONE_VALIDATION,
    // address: Yup.string().max(TEXTAREA_MAX_LENGTH,"validation_max_input_characters").trim().required(("label_location_error")),
    // profile_image: Yup.mixed()
    //   .nullable()
    //   .test(
    //     'fileOrUrl',
    //     'supported_file_error',
    //     value => {
    //       if (!value) return true;
    //       if (typeof value === 'string') return /^(http|https):\/\/[^\s$.?#].[^\s]*$/gm.test(value);
    //       return ['image/jpg', 'image/jpeg', 'image/png', 'image/webp', 'image/gif'].includes(value.type);
    //     }
    //   )
    //   .test(
    //     'fileSize',
    //     'image_max_size_error',
    //     value => {
    //       if (!value || typeof value === 'string') return true;
    //       return value.size <= 1.5 * 1024 * 1024;
    //     }
    //   ),

  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {

      name: showdefault && showdefault.name ? showdefault.name : "",

      email: showdefault && showdefault.email ? showdefault.email : "",
      phone_number: showdefault && showdefault?.phone_number ? showdefault?.phone_number : "",
      // address: showdefault && showdefault.address ? showdefault.address : "",
      profile_image: showdefault && showdefault.profile_image ? showdefault.profile_image : "",
      isUserDeactivated: showdefault && showdefault.isUserDeactivated ? showdefault.isUserDeactivated : false,
      isFreeAccess: showdefault && showdefault.isFreeAccess ? showdefault.isFreeAccess : false,
    },
    validationSchema: validationSchema,
    onSubmit: (values, { setSubmitting, resetForm }) => {
      globalLoader(true);
      let formData = new FormData();
      formData.append("_id", params._id);
      // formData.append("name", values.name);
      formData.append("name", values.name);
      formData.append("email", values.email);
      formData.append("phone_number", values.phone_number);
      formData.append("address", values.address);
      formData.append("profile_image", values.profile_image);
      formData.append("isUserDeactivated", values.isUserDeactivated);
      formData.append("isFreeAccess", values.isFreeAccess);


      EditUser(formData)
        .then((response) => {
          setSubmitting(false);
          if (response.success) {
            Swal.fire({
              icon: "success",
              text: response.message,
              ...SWAL_SETTINGS,
            });
            globalLoader(false);
            if (saveType !== "Save") {
              navigate(`/admin/babe-user/list/1`);
            }
          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
          }
          globalLoader(false);
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            text: handleServerValidations(error),
            ...SWAL_SETTINGS,
          });
          console.log("error ====> ", error);
        });
    },
  });
  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <form onSubmit={formik.handleSubmit}>
        <div className="row row-sm">
          <div className="col-lg-12 col-md-12 animation_fade">
            <div className="card custom-card">
              <div className="card-body">
                <div>
                  <h6 className="main-content-label mb-3">
                    {t("edit_user")}
                  </h6>
                </div>
                <div className="row row-sm">

                  <div className="col-md-6 text-center form-group">
                    <label htmlFor="name" className="text-left d-flex">
                      {t("label_name")}:
                      <span className="requirestar">*</span>{" "}
                    </label>
                    <input
                      name="name"
                      id="name"
                      type="text"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.name}
                      className="form-control"
                      placeholder={t("label_enter_name")}
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError shortCodes={[INPUT_MAX_25]} name="name" form={formik} />
                    </span>
                  </div>

                  <div className="col-lg-6 text-center form-group">
                    <label htmlFor="email" className="text-left d-flex">
                      {t("label_email")}:<span className="requirestar">*</span>{" "}
                    </label>
                    <input
                      name="email"
                      id="email"
                      type="text"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.email}
                      className="form-control"
                      placeholder={t("placeholder_email")}
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError name="email" form={formik} />
                    </span>
                  </div>
                  {/* <div className="col-md-6 text-center form-group">
                    <label htmlFor="address" className="text-left d-flex">
                      {t("label_address")}:
                      <span className="requirestar">*</span>{" "}
                    </label>
                    <input
                      name="address"
                      id="address"
                      type="text"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.address}
                      className="form-control"
                      placeholder={t("web_inquiry_form_placeholder_address")}
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError shortCodes={[TEXTAREA_MAX_LENGTH]} name="address" form={formik} />
                    </span>
                  </div> */}
                  <div className="col-md-6 text-center form-group">
                    <label className="text-left d-flex" htmlFor="phone_number">
                      {t("label_phone_number")}:
                      <span className="requirestar">*</span>{" "}
                    </label>
                    <PhoneInput
                      name="phone_number"
                      id="phone_number"
                      placeholder={t('phone_number_placeholder')}
                      onChange={(e) => { formik.setFieldValue('phone_number', e?.phone_number) }}
                      onBlur={formik.handleBlur}
                      value={formik.values.phone_number}
                      className="form-control"
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError name="phone_number" form={formik} shortCodes={{ PHONE_MIN_LENGTH: PHONE_NO_LENGTH.min, PHONE_MAX_LENGTH: PHONE_NO_LENGTH.max }} />
                    </span>
                  </div>




                  <div className="col-lg-6 text-center form-group">
                    <label htmlFor="profile_image" className="text-left d-flex">
                      {t("label_logo")}:
                      {" "}
                      <Whisper
                        placement="top"
                        controlId="control-id-hover"
                        trigger="hover"
                        speaker={
                          <Tooltip>
                            {t("image_support_tooltip")}
                          </Tooltip>
                        }
                      >
                        <span className="field-more-info mt-1 ms-1 cp">
                          ?
                        </span>
                      </Whisper>
                    </label>
                    <input
                      className="form-control imgInput"
                      id="profile_image"
                      name="profile_image"
                      accept="image/*"
                      type="file"
                      onChange={(event) => {
                        formik.setFieldValue(
                          "profile_image",
                          event.target.files[0] || ""
                        );
                        event.target.files.length === 1
                          ? setPreviewImage(
                            URL.createObjectURL(event.target.files[0])
                          )
                          : setPreviewImage("");
                      }}
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError name="profile_image" form={formik} />
                    </span>
                    {previewimage ? (
                      <ul className="question-image-preview questions-ul">
                        <li className="pr_img_box">
                          <img
                            src={previewimage}
                            style={{ height: "100px" }}
                            alt={"profileImg"}
                          />

                        </li>
                      </ul>
                    ) : (
                      ""
                    )}
                  </div>


                  <div className="col-md-3 text-center form-group">
                    {/* Flex container for two toggles */}
                    <div className="d-flex  align-items-center">
                      {/* Toggle One */}
                      <div className="d-flex align-items-start flex-column">
                        <label className="text-left d-flex ">User Deactivate Status</label>
                        <label className={"custom-switch cp mt-2" + (formik.values.isUserDeactivated === true ? " e_none" : "")}>
                          <input className="custom-switch-input cp" name="isUserDeactivated" type="checkbox" onChange={()=>formik.setFieldValue('isUserDeactivated', !formik.values.isUserDeactivated)} onBlur={formik.values.handleBlur} value={formik.values.isUserDeactivated} checked={formik.values?.isUserDeactivated} />
                          <span className="custom-switch-indicator cp"></span>
                        </label>
                      </div>

                    </div>
                  </div>


                  <div className="col-md-3 text-center form-group">
                    {/* Flex container for two toggles */}
                    <div className="d-flex  align-items-center">
                      {/* Toggle One */}
                      <div className="d-flex align-items-start flex-column">
                        <label className="text-left d-flex ">Grant Free Access</label>
                        <label className={"custom-switch cp mt-2" + (formik.values.isFreeAccess === true ? " e_none" : "")}>
                          <input className="custom-switch-input cp" name="isFreeAccess" type="checkbox" onChange={()=>formik.setFieldValue('isFreeAccess', !formik.values.isFreeAccess)} onBlur={formik.values.handleBlur} value={formik.values.isFreeAccess} checked={formik.values?.isFreeAccess} />
                          <span className="custom-switch-indicator cp"></span>
                        </label>
                      </div>

                    </div>
                  </div>

                  <div className="mt-5">
                    <button
                      onClick={() => {
                        setSaveType("Save");
                      }}
                      className="btn btn-info mr-2"
                      type="submit"
                    >
                      <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                      {t("btn_save")}
                    </button>
                    <button
                      onClick={() => {
                        setSaveType("");
                      }}
                      className="btn btn-success mr-2"
                      type="submit"
                    >
                      <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                      {t("btn_save_exit")}
                    </button>
                    <button
                      className="btn ripple btn-secondary"
                      type="button"
                      onClick={() => navigate(-1)}
                    >
                      <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                      {t("btn_cancel")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default BabeUserEdit;